import React, { useEffect, useState } from "react";
import "./Flyers.css";
import { Flex, SafeArea } from "../../components/layout";
import { Image, ImageViewer } from "../../components/ui";
import { Link, useParams } from "react-router-dom";
import { db } from "../../components/firebase/firebase";
import { doc, getDoc } from "firebase/firestore";
import { HiArrowLeft } from "react-icons/hi";
import { logEvent, serializeError } from "../../utils/logger";

function Flyers() {
  const [data, setData] = useState({});
  const [viewer, setViewer] = useState(false);
  const [index, setIndex] = useState(0);

  const { id } = useParams();

  useEffect(() => {
    const fetchWorkshop = async () => {
      try {
        const docRef = doc(db, "calendar", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setData(docSnap.data());
        }
      } catch (err) {
        console.log("Une erreur est survenue lors du chargement de l'atelier.");
        logEvent("ERROR", "DB", "Failed to fetch flyer details", {
          error: serializeError(err),
          collection: "calendar",
          documentId: id,
        });
      }
    };

    fetchWorkshop();
  }, [id]);
  return (
    <SafeArea className="Flyers">
      <Flex>
        <Link to="/calendrier" className="back">
          <HiArrowLeft />
          Séjours à venir et passés
        </Link>
      </Flex>
      <Flex type="col-center" gap={80}>
        <div className="title-container">
          <h2 dangerouslySetInnerHTML={{ __html: data.title || "" }}></h2>
        </div>
        {data &&
          data?.img?.length > 0 &&
          data.img.map((item, index) => (
            <Flex type="center" className="content" gap={20} wrap>
              <Image
                key={index}
                src={item}
                alt="flyer"
                onClick={() => {
                  setViewer(true);
                  setIndex(index);
                }}
              />
            </Flex>
          ))}
        {(!data?.img || data?.img?.length === 0) && !data?.description && (
          <p>Flyer en cours de préparation.</p>
        )}
        {data.description && (
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: data.description,
            }}
          />
        )}
      </Flex>
      {viewer && (
        <ImageViewer
          index={index}
          images={data.img}
          closeViewer={() => setViewer(false)}
        />
      )}
    </SafeArea>
  );
}

export default Flyers;
